import React, { useEffect, useState } from "react";

import OverlayWrapper from "./OverlayWrapper";
import PropTypes from "prop-types";
import Transition from "react-transition-group/Transition";
import { injectModel } from "core-web/state";
import loadable from "@loadable/component";

// Load in assets from theme/overlays.
let activeOverlay = null;
const overlays = {
    sub_menu_overlay: loadable(() => import("theme/overlays/SubMenuOverlay")),
    basket_overlay: loadable(() => import("theme/overlays/BasketOverlay")),
    user_overlay: loadable(() => import("theme/overlays/UserOverlay")),
    filter_overlay: loadable(() => import("theme/overlays/FilterOverlay")),
    gallery_zoom_overlay: loadable(() => import("theme/overlays/GalleryZoomOverlay")),
    nav_desktop: loadable(() => import("theme/overlays/Navigation/NavOverlayDesktop")),
    nav_mobile: loadable(() => import("theme/overlays/Navigation/NavOverlayMobile")),
    search: loadable(() => import("theme/overlays/SearchOverlay")),
    relations_overlay: loadable(() => import("theme/overlays/RelationsOverlay")),
    content_page_nav_overlay: loadable(() => import("theme/overlays/ContentPageNavOverlay")),
    sort_overlay: loadable(() => import("theme/overlays/SortOverlay")),
    wrong_country_overlay: loadable(() => import("theme/overlays/WrongCountryOverlay")),
};

const DURATION = 300;

const Overlay = ({ overlay }) => {
    const { data, wrapper, current } = overlay;
    const [currentOverlayName, setCurrentOverlayName] = useState(current);
    const Wrapper = wrapper ? wrapper : OverlayWrapper;

    useEffect(() => {
        if (current && !currentOverlayName) {
            setCurrentOverlayName(current);
        } else {
            setCurrentOverlayName(null);
            if (current) {
                setTimeout(() => {
                    setCurrentOverlayName(current);
                }, DURATION);
            }
        }
    }, [current]);

    const currentOverlay = current && overlays[currentOverlayName] !== undefined && overlays[currentOverlayName];
    const ActiveOverlay = currentOverlay || activeOverlay;
    activeOverlay = ActiveOverlay;

    return (
        <Transition
            mountOnEnter
            unmountOnExit
            enter
            in={!!currentOverlay}
            timeout={{
                appear: 0,
                enter: 50,
                exit: 200,
            }}
        >
            {(state) => (
                <Wrapper className={state} duration={DURATION} zIndex={data?.zIndex} isInCheckout={data?.isInCheckout}>
                    <ActiveOverlay {...(data || {})} />
                </Wrapper>
            )}
        </Transition>
    );
};

Overlay.propTypes = {
    overlay: PropTypes.shape({
        current: PropTypes.string,
        data: PropTypes.object,
        wrapper: PropTypes.node,
    }).isRequired,
};

export default injectModel("overlay")(Overlay);
